import './Home.css';
import Navbar from '../../components/navbar/Navbar';
import Xlr8Ascii from '../../components/xlr8ascii/xlr8Ascii';

function Home() {
  return (
    <div className="home-container">
      <Navbar/>
      <Xlr8Ascii/>
    </div>
  );
}

export default Home;